import { ScanEyeIcon } from "lucide-react";
import { Button } from "src/components/ui/button";
import { UrlImage } from "src/lib/api";
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "src/components/ui/dialog";
import { DialogDeleteAnswer } from "./DialogDeleteAnswer";
import { useLanguage } from "../../../../../../context/LanguageContext";
import { SubLessonData } from "../../../../../../lib/languages";

export function DialogShowAnswer({
  answers,
  loading,
  onOpen,
  isTable = false,
}) {
  const { language } = useLanguage();
  const t = SubLessonData[language] || SubLessonData.en;

  return (
    <Dialog onOpenChange={(open) => (!isTable ? open && onOpen() : null)}>
      <DialogTrigger asChild>
        <Button variant="ghost" size="sm" className="text-primary h-7">
          <ScanEyeIcon className="h-4 w-4 me-1 text-blue-600" />
          {t.homeworkShowAnswers}
        </Button>
      </DialogTrigger>
      <DialogContent
        className="sm:max-w-[425px]"
        dir={language === "ar" ? "rtl" : "ltr"}
      >
        <DialogHeader>
          <DialogTitle>{t.dialogFilesTitle}</DialogTitle>
          <DialogDescription>{t.dialogFilesDescription}</DialogDescription>
        </DialogHeader>

        <div className="flex flex-col space-y-4">
          {loading ? (
            <p className="text-center py-4">{t.loading}</p>
          ) : answers?.length > 0 &&
            answers.some((ans) => ans.files?.length > 0) ? (
            answers.map(
              (ans) =>
                ans.files?.length > 0 && (
                  <div key={ans.id} className="flex flex-col space-y-2">
                    {/* Answerer name and title with delete */}
                    <div className="flex items-center justify-between">
                      <p className="font-semibold">{ans.title}</p>
                      <DialogDeleteAnswer
                        item={ans}
                        fetchAnswers={() => onOpen()}
                      />
                    </div>

                    {/* Files */}
                    <ul className="list-disc list-inside flex flex-col space-y-1">
                      {ans.files.map((filePath, idx) => (
                        <li>
                          <a
                            key={idx}
                            className="hover:underline truncate flex-1 list"
                            href={`${UrlImage}${filePath}`}
                            download
                            target="_blank"
                            rel="noreferrer"
                          >
                            {ans.title}
                            {idx + 1}.{filePath.split(".").pop()}
                          </a>
                        </li>
                      ))}
                    </ul>
                  </div>
                )
            )
          ) : (
            <p>No Files Exist</p>
          )}
        </div>

        <DialogClose asChild>
          <Button className="mt-4">{t.close}</Button>
        </DialogClose>
      </DialogContent>
    </Dialog>
  );
}
